module.exports = "https://img.zhijierongxing.com/saas/img/pup_close.408d021d.png";